'use strict';

const _ = require('underscore');
const d3 = require('d3');
const Victor = require('victor');
const NodeView = require('common/ui/view/svg/node');
const PortView = require('common/ui/view/svg/port');
const IconView = require('common/ui/view/svg/icon');
const TextlabelView = require('common/ui/view/svg/text/label');
const TextrectView = require('common/ui/view/svg/text/rect');
const SVGUtil = require('common/ui/view/svg/util');
const VectorUtil = require('common/vector-util');
const ImageHelper = require('common/ui/template/helper/image');
const ElementAction = require('system/domain/action/element');
const RecordTypeRepository = require('system/domain/repository/record-type');
const ElementRepository = require('system/domain/repository/element');
const TagRepository = require('system/domain/repository/tag');
const ProjectRepository = require('common/domain/repository/project');
const SyncStatesModel = require('system/domain/entity/sync-states');
const ElementService = require('system/domain/service/element');
const CommentCounterView = require('system/ui/view/element-communication/comment-counter-view');
const TaskCounterView = require('system/ui/view/element-communication/task-counter-view');

const InterfacePortView = PortView.extend({
    portViewOptions: function() {
        return {
            nodeView: this,
            diagram: this.diagram
        }
    },
    initialize: function(options) {
        InterfacePortView.__super__.initialize.call(this, options);
        _.bindAll(this, 'onMouseOver', 'onMouseOut');
        this.diagram = options.diagram;
        this._context = this.getOption('context');
        this._channel = this.getOption('channel');
        this._members = this.getOption('members');

        this.listenTo(this.model, 'change:interface', this.renderIcon);
        this.listenTo(this.model, 'change:name', this.renderName);
        this.listenTo(this.model, 'select', this.select);
        this.listenTo(this.model, 'deselect', this.deselect);
        this.listenTo(this._channel, 'port:linker:render',
            function(model, view) {
                this.removeLinker();
                if(this.model == model) {
                    return;
                }
                this.sourceModel = model;
                const angle = VectorUtil.angle(this.getCenterPoint(), view.getCenterPoint());
                this.renderLinker(angle);
            });
    },
    onRender: function() {
        InterfacePortView.__super__.onRender.call(this);
        this.$el.on('mouseover', this.onMouseOver);
        this.$el.on('mouseout', this.onMouseOut);
        this.renderIcon();
    },
    select: function() {
        this.$el.classed('is-active', true);
    },
    deselect: function() {
        this.$el.classed('is-active', false);
    },
    onMouseOver: function() {
        this.$el.classed('is-hover', true);
        this.stopEvent();
    },
    onMouseOut: function() {
        this.$el.classed('is-hover', false);
        this.stopEvent();
    },
    onClick: function() {
        this.model.click();
    },
    onClickLinker: function(pos) {
       this._channel.request('canvas:addPortLink',
                this.sourceModel, this.model, pos);
    },

    renderIcon: function() {
        this.$el.selectAll('.port-icon').remove();
        const interface_ = this.model.get('interface_');
        if(!interface_) {
            return;
        }

        const interfaceType = ElementRepository
            .getInterfaceTypes({context: this._context})
            .get(interface_);
        if(!interfaceType) {
            return;
        }

        const directions = _.pluck(interfaceType.get('flows'), 'direction');
        let klass = '';
        let offset = {x: 0, y: 0};
        let size = 36;
        if(_.contains(directions, 'inout') ||
            (_.contains(directions, 'in') && _.contains(directions, 'out'))) {
            klass = 'fa fa-arrows-v';
            size = 48;
        } else if (_.contains(directions, 'in')) {
            klass = 'fa fa-arrow-up';
            offset = {x: 0, y: -8};
        } else if (_.contains(directions, 'out')) {
            klass = 'fa fa-arrow-down';
            offset = {x: 0, y: 8};
        } else {
            return
        }

        const iconView = new IconView({
            size: size,
            class: klass,
            offset: offset
        });
        const angle = this.nodeView.getBorderPoint(this.model.get('degree')).angle + 270;
        iconView.$el.classed('port-icon', true)
            .attr('transform', SVGUtil.transform({
                x: 0,
                y: 0,
                rotate: angle
            }));
        this.$el.append(iconView.render().el);
    }
});

module.exports = NodeView.extend({
    className: 'node',
    draggable: true,
    syncState: function() {
        return new SyncStatesModel({models: [
            this.model.syncState,
            this.meta.syncState

        ]})
    },
    label: function() {
        return this.getType().get('name');
    },
    content: function() {
        if(this.getType().get('hideName')) {
            return null;
        }
        if(this.model.get('image_url')) {
            return null;
        }
        return this.model.get('name');
    },
    shapeViewClass: function() {
        if(this.meta.get('is_zone')) {
            return this.meta.get('shape').kind;
        }
        return this.getType().get('shape').kind;
    },
    shapeViewOptions: function() {
        if(this.meta.get('is_zone')) {
            const attr = _.clone(this.getType().get('shape').attr);
            return _.extend(attr, this.meta.get('shape').attr);
        }
        return this.getType().get('shape').attr;
    },
    portViewClass: InterfacePortView,
    portViewOptions: function() {
        return {
            nodeView: this,
            diagram: this.diagram
        }
    },
    locator: function() {
        return this.meta;
    },
    listenToAll: function(target, events, callback) {
        _.each(events, function(e) {
            this.listenTo(target, e, callback);
        }, this);
    },
    getType: function() {
        const type = this.model.get('type');
        return RecordTypeRepository.getRecordTypes().get(type);
    },
    initialize: function(params) {
        this.meta = params.meta;
        this.diagram = params.diagram;
        this._context = this.getOption('context');
        this._channel = this.getOption('channel');
        this._auth = this.getOption('auth');
        this._members = this.getOption('members');

        this.constructor.__super__.initialize.call(this, params);
        this.listenTo(this.model, 'select', this.select);
        this.listenTo(this.model, 'deselect', this.deselect);
        this.listenTo(this.model, 'change:name', this.render);
        this.listenTo(this.model, 'change:type', this.render);
        this.listenTo(this.model, 'change:tags', this.render);
        this.listenTo(this.model, 'change:owners', this.render);
        this.listenTo(this.model, 'change:image_url', this.render);
        this.listenTo(this.model, 'change:deleting', this.render);
        this.listenTo(this.model, 'change:deleted', this.remove);
        this.listenTo(this.model, 'highlight', this.highlight);
        this.listenTo(this.model, 'dehighlight', this.dehighlight);
        this.listenTo(this.meta, 'move', function() {
            this.calcPos();
            this.move();
        });
        this.listenTo(this.meta, 'change:is_zone', this.render);
        this.listenTo(this.meta, 'change:shape', this.render);
        this.listenTo(this.meta, 'change:deleting', this.render);
        this.listenTo(this.meta, 'change:deleted', this.remove);
        this.listenTo(this.meta, 'remove', this.remove);
        this.listenTo(this._channel, 'linker:render',
            function(model, meta) {
                this.removeLinker();
                if(this.model == model) {
                    return;
                }
                this.sourceModel = model;
                const angle = VectorUtil.angle(this.meta, meta);
                this.renderLinker(angle);
            });
        this.listenTo(this._channel, 'linker:remove',
            this.removeLinker);
        this.listenTo(this.meta, 'move', this.move);
        this.listenTo(this.meta, 'moveEnd',function(pos) {
            ElementAction.startEditNode({
                context: this._context,
                node: {id: this.meta.id}
            });
            ElementAction.updateNode({
                context: this._context,
                nodeMeta: {
                    id: this.meta.id,
                    x: pos.x,
                    y: pos.y
                }
            });
            this.trigger('move:end');
        });
        this.listenToAll(TagRepository.getTags({
            context: this._context
        }), ['add', 'change', 'remove', 'reset'], this.renderTags);
        this.listenToAll(TagRepository.getCategories({
            context: this._context
        }), ['add', 'change', 'remove', 'reset'], this.renderTags);
        this.listenToAll(this._members,
            ['add', 'change', 'remove', 'reset'], this.render);
        this.listenToAll(ElementRepository.getLinks({
            context: this._context
        }), ['add', 'reset'], this.render);
    },

    onRender: function() {
        this.constructor.__super__.onRender.call(this);
        if(this.model.selected) {
            this.select();
        }
        if(this.meta.get('is_zone')) {
            this.shapeView.renderSizeChanger();
        }
        this.renderDiffState();
        this.renderIcons();
        this.renderTags();
        this.renderOwners();
        this.renderCommunicationCounters();
        const imageUrl = this.model.get('image_url');
        if(imageUrl) {
            this.renderImage(ImageHelper(imageUrl, 'large'));
        } else {
            this.removeImage();
        }
        if(this.model.get('deleting') || this.meta.get('deleting')) {
            this.$el.style('opacity', '0.5');
        } else {
            this.$el.style('opacity', null);
        }
        this.renderProjectedDiagrams();
        this.move();
        this.listenTo(this.shapeView, 'change:size:end',
            function(attr, offset) {
                let shape = this.meta.get('shape');
                shape = {
                    kind: shape.kind,
                    attr: attr
                };
                this.meta.x += offset.x;
                this.meta.y += offset.y;
                this.meta.moveend();
                ElementAction.updateNode({
                    context: this._context,
                    nodeMeta: {
                        id: this.meta.id,
                        x: this.meta.x,
                        y: this.meta.y,
                        shape: shape
                    }
                });
                this.render();
            });
    },

    onDrag: function(pos, dpos) {
        if(!this._auth.isMovable()) {
            return;
        }
        this.constructor.__super__.onDrag.call(this, pos, dpos);
        dpos = {
            dx: dpos.x,
            dy: dpos.y
        };
        if (this.meta.custom_move && this.model.selected) {
            this.meta.custom_move(dpos);
        } else {
            this.meta.move(dpos);
        }
    },

    onDragEnd: function(pos) {
        if(!this._auth.isMovable()) {
            return;
        }
        if (this.meta.custom_move && this.model.selected) {
            this.meta.custom_moveend();
        } else {
            this.meta.moveend();
        }
        this.calcPos();
        this.constructor.__super__.onDragEnd.call(this, pos);
    },

    onClick: function(pos) {
        this.model.click();
    },

    onDoubleClick: function(pos) {
        this.model.doubleClick();
    },

    onClickLinker: function(pos) {
        this._channel.request('canvas:addLink',
            this.sourceModel, this.model, pos);
    },

    move: function() {
        this.$el.attr('transform', SVGUtil.transform(this.locator()));
        this.trigger('move');
    },

    select: function() {
        this.$el.classed('is-active', true);
    },

    deselect: function() {
        this.$el.classed('is-active', false);
    },

    highlight: function() {
        this.$el.classed('is-highlighted', true);
    },

    dehighlight: function() {
        this.$el.classed('is-highlighted', false);
    },

    renderDiffState: function() {
        const diff = this.model.diff;
        const pos = this.shapeView.getBorderPoint(Victor(-1, -1));
        this.$el.selectAll('.node-diff').remove();
        if(!diff || !diff.changed) {
            return
        }

        let klass = '';
        if(!diff.to){
            klass = 'node-diff-delete';
        } else if (!diff.from) {
            klass = 'node-diff-add';
        }
        const text = diff.diffId;

        const diffView = this.$el.append('g')
            .classed('node-diff', true);
        diffView.append('circle')
            .attr('r', 40)
            .attr('cx', 0)
            .attr('cy', 0)
            .classed(klass, true);

        const icon = new IconView({
            text: text,
            offset: {x: 0, y: -4},
            size: 64,
            fontSize: 32
        });
        diffView.append(icon.render().el);
        diffView.attr('transform', SVGUtil.transform(pos));
    },

    renderIcon: function(params) {
        if(params.to_render) {
            if(!this[params.name]) {
                this[params.name] = this.$el.append(
                    (new IconView({
                        class: params.faclass,
                        offset: params.offset,
                        size: params.size
                    })).render().el)
                    .classed('node-icon', true);
            }
        } else {
            if(this[params.name]) {
                this[params.name].remove();
                this[params.name] = null;
            }
        }
    },

    renderIcons: function() {
        this.$el.selectAll('.node-icon').remove();
        const self = this;
        const icons = [
            {
                to_render: this.model.get('description'),
                name: '$descIcon',
                faclass: 'fa fa-file-text',
                size: 28
            },
            {
                to_render: this._members.getMembersByUserId(
                    this.model.get('owners')).length > 0,
                name: '$ownerIcon',
                faclass: 'fa fa-user',
                size: 28
            },
            {
                to_render: ElementRepository
                    .getLinks({context: this._context})
                    .chain()
                    .filter(function(link) {
                        return !link.get('deleted');
                    })
                    .filter(function(link) {
                        return !self.diagram.hasLink(link);
                    })
                    .filter(function(link) {
                        return link.source.id == self.model.id ||
                            link.target.id == self.model.id;
                    })
                    .value().length > 0,
                name: '$linkIcon',
                faclass: 'fa fa-link',
                size: 28
            }

        ];
        const points = this.shapeView.getBottomLeftPoints({
            interval: 42
        });

        _.each(icons, _.bind(function(icon, i) {
            if(i > points.length - 1 || !icon.to_render) {
                return;
            }
            icon.offset = points[i];
            this.$el.append(
                (new IconView({
                    class: icon.faclass,
                    offset: icon.offset,
                    size: icon.size
                })).render().el)
                .classed('node-icon', true);
        }, this));
    },

    renderTags: function() {
        const _renderer = _.bind(function(points) {
            return _.bind(function(tag, i) {
                if(i > points.length - 1) {
                    return;
                }
                const p = points[i];

                const r = tag.selected() ? 64 : 16;

                this.$el.append('circle')
                    .classed('tag', true)
                    .classed('is-active', tag.selected())
                    .style('fill', tag.get('color'))
                    .attr('r', r)
                    .attr('cx', p.x)
                    .attr('cy', p.y);
            }, this);
        }, this);

        const _exposedRenderer = _.bind(function(point) {
                return _.bind(function(tag, i) {
                    const textLabel = new TextrectView({
                        offset: {x: point.x - 200, y: point.y + 56 * (i + 1) - 28},
                        bgcolor: tag.get('color'),
                        size: 36,
                        text: tag.get('name')
                    });
                    this.$el.append('g')
                        .classed('tag', true)
                        .append(textLabel.render().el);
                }, this);
        }, this);

        this.$el.selectAll('.tag').remove();
        const tags = TagRepository.getTags({
            context: this._context
        }).getByIds(this.model.get('tags'));

        let r = 16;
        const notSelectedTags = _.filter(tags, function(tag) {
            return !tag.selected();
        });
        let points = this.shapeView.getBottomRightPoints({
            interval: r / 2 * 3
        });
        _.each(notSelectedTags, _renderer(points));

        r = 24;
        const selectedTags = _.filter(tags, function(tag) {
            return tag.selected();
        });

        points = this.shapeView.getBottomRightPoints({
            interval: r / 2 * 3
        });
        _.each(selectedTags, _renderer(points));

        const exposedTags = _.filter(tags, tag => tag.isExposed());
        _.each(exposedTags, _exposedRenderer(points[0]));
    },

    renderOwners: function() {
        const _renderer = _.bind(function(points) {
            return _.bind(function(owner, i) {
                if(i > points.length - 1) {
                    return;
                }
                const p = points[i];

                const image_url = owner.getUser().getImageURL();
                const image_size = 128;
                const image_offset = 64;
                const id = owner.id + ':' + this.model.id;
                this.$el
                    .append('svg:pattern')
                    .classed('owner-image', true)
                    .attr('width', image_size)
                    .attr('height', image_size)
                    .attr('x', p.x - image_offset)
                    .attr('y', p.y - image_offset)
                    .attr('patternUnits', 'userSpaceOnUse')
                    .attr('id', id)
                    .append('image')
                    .attr('width', 128)
                    .attr('height', 128)
                    .attr(
                        'xlink:href',
                        ImageHelper(image_url, 'large')
                    );
                const r = owner.selected() ? 64 : 16;
                this.$el.append('circle')
                    .classed('owner', true)
                    .classed('is-active', owner.selected())
                    .style('fill', 'url(#' + id + ')')
                    .attr('r', r)
                    .attr('cx', p.x)
                    .attr('cy', p.y);
            }, this);
        }, this);

        this.$el.selectAll('.owner').remove();
        this.$el.selectAll('.owner-image').remove();
        const owners = this._members.getMembersByUserId(this.model.get('owners'));
        const selectedOwners = _.filter(owners, function(owner) {
            return owner.selected();
        });

        const r = 24;
        const points = this.shapeView.getBottomLeftPoints({
            interval: r / 2 * 3
        });
        _.each(selectedOwners, _renderer(points));
    },

    renderCommunicationCounters: function() {
        // 新規作成されたばかり(保存前)の場合は処理スキップ
        if (!this.model.key.kind) {
            return;
        }

        const params = {
            width: 128,
            height: 64,
            fontSize: 64,
            badgeFontSize: 32,
        };

        const commentsCounterPos = this.shapeView.getBorderPoint(
            Victor(1, 0).rotateDeg(-50),
            64
        );
        const tasksCounterPos = {
            x: commentsCounterPos.x + params.width - 10,
            y: commentsCounterPos.y,
        };

        const oldContext = this._context;
        ProjectRepository.getProject(oldContext.projectId)
            .then(project => {
                this._renderCommentsCounter(project, this.model.key, params, commentsCounterPos);
                this._renderTasksCounter(project, this.model.key, params, tasksCounterPos);
            });
    },

    _renderCommentsCounter: function(project, key, params, offset) {
        this.$el.selectAll('.element-comments-counter').remove();

        const commentCounterView = new CommentCounterView({
            project: project,
            key: key,
            hasComment: this.model.hasRelatedComment(),
            class: 'fa fa-comments-o',
            bgclass: 'element-communication-counter',
            width: params.width,
            height: params.height,
            fontSize: params.fontSize,
            offset: offset,
            badgeFontSize: params.badgeFontSize,
        });
        this.$el.append('g')
            .append(commentCounterView.render().el)
            .classed('element-comments-counter', true);
    },

    _renderTasksCounter: function(project, key, params, offset) {
        this.$el.selectAll('.element-tasks-counter').remove();

        const taskCounterView = new TaskCounterView({
            project: project,
            key: key,
            hasTask: this.model.hasRelatedTask(),
            class: 'fa fa-check-square',
            bgclass: 'element-communication-counter',
            width: params.width,
            height: params.height,
            fontSize: params.fontSize * 0.9,
            offset: offset,
            badgeFontSize: params.badgeFontSize,
        });
        this.$el.append('g')
            .append(taskCounterView.render().el)
            .classed('element-tasks-counter', true);
    },

    renderProjectedDiagrams: function() {
        this.$el.selectAll('.record-diagram').remove();
        // 同一のノードが射影されているダイアグラム一覧を取得
        const diagrams = ElementService.getProjectedDiagrams({
            context: this._context,
            model: this.model
        });
        if(diagrams.length == 0) {
            return;
        }

        const p = this.shapeView.getBorderPoint(Victor(1, 0).rotateDeg(-135), 64);
        _.each(diagrams, function(d) {
            const g = this.$el.append('g');
            const view = new IconView({
                class: 'fa fa-link',
                bgclass: 'icon icon-lg diagram-type-' + d.get('type'),
                size: 48,
                fontSize: 28
            });
            g.append(view.render().el);
            g.classed('record-diagram', true)
                .attr('transform', SVGUtil.transform(p))
                .style('opacity', 0.4)
                .on('mouseenter', function() {
                    g.style('opacity', 0.8);
                    const label = new TextlabelView({
                        offset: {x: 0, y: -48},
                        size: 36,
                        text: d.get('name')
                    });
                    g.append(label.render().el);
                    label.$el.classed('diagram-name', true);
                })
                .on('mouseleave', function() {
                    g.style('opacity', 0.4);
                    g.selectAll('.diagram-name').remove();
                });
            p.x += 32;
        }, this);
    }
});



// WEBPACK FOOTER //
// ./system/ui/view/element/record.js